export const SERVER_URL = 'https://rslang-team75.herokuapp.com';
